<template>
  <div class="exposure">
    <AnalysisCardSelection
      v-if="!analysisType"
      module-name="Environment Factors"
      module-description="Explore lifestyle, diet, and exposure-related factors associated with health outcomes."
      base-path="/exposure"
    />

    <template v-else>
      <div class="bg-decoration">
        <svg class="molecule-bg molecule-bg-1" viewBox="0 0 400 400" fill="none">
          <circle cx="200" cy="80" r="6" fill="#fca5a5" opacity="0.6"/>
          <circle cx="120" cy="140" r="5" fill="#fca5a5" opacity="0.5"/>
          <circle cx="280" cy="140" r="7" fill="#fca5a5" opacity="0.7"/>
          <circle cx="80" cy="220" r="4" fill="#fca5a5" opacity="0.4"/>
          <circle cx="200" cy="200" r="8" fill="#fca5a5" opacity="0.8"/>
          <circle cx="320" cy="220" r="5" fill="#fca5a5" opacity="0.5"/>
          <circle cx="150" cy="280" r="6" fill="#fca5a5" opacity="0.6"/>
          <circle cx="250" cy="280" r="5" fill="#fca5a5" opacity="0.5"/>
          <circle cx="200" cy="350" r="4" fill="#fca5a5" opacity="0.4"/>
          <line x1="200" y1="80" x2="120" y2="140" stroke="#fca5a5" stroke-width="1" opacity="0.3"/>
          <line x1="200" y1="80" x2="280" y2="140" stroke="#fca5a5" stroke-width="1" opacity="0.3"/>
          <line x1="120" y1="140" x2="80" y2="220" stroke="#fca5a5" stroke-width="1" opacity="0.3"/>
          <line x1="120" y1="140" x2="200" y2="200" stroke="#fca5a5" stroke-width="1" opacity="0.3"/>
          <line x1="280" y1="140" x2="200" y2="200" stroke="#fca5a5" stroke-width="1" opacity="0.3"/>
          <line x1="280" y1="140" x2="320" y2="220" stroke="#fca5a5" stroke-width="1" opacity="0.3"/>
          <line x1="200" y1="200" x2="150" y2="280" stroke="#fca5a5" stroke-width="1" opacity="0.3"/>
          <line x1="200" y1="200" x2="250" y2="280" stroke="#fca5a5" stroke-width="1" opacity="0.3"/>
          <line x1="150" y1="280" x2="200" y2="350" stroke="#fca5a5" stroke-width="1" opacity="0.3"/>
          <line x1="250" y1="280" x2="200" y2="350" stroke="#fca5a5" stroke-width="1" opacity="0.3"/>
          <line x1="80" y1="220" x2="150" y2="280" stroke="#fca5a5" stroke-width="1" opacity="0.3"/>
          <line x1="320" y1="220" x2="250" y2="280" stroke="#fca5a5" stroke-width="1" opacity="0.3"/>
        </svg>

        <svg class="bars-bg" viewBox="0 0 200 300" fill="none">
          <rect x="10" y="150" width="12" height="150" fill="#fca5a5" opacity="0.15"/>
          <rect x="30" y="100" width="12" height="200" fill="#fca5a5" opacity="0.12"/>
          <rect x="50" y="120" width="12" height="180" fill="#fca5a5" opacity="0.18"/>
          <rect x="70" y="80" width="12" height="220" fill="#fca5a5" opacity="0.1"/>
          <rect x="90" y="140" width="12" height="160" fill="#fca5a5" opacity="0.15"/>
          <rect x="110" y="90" width="12" height="210" fill="#fca5a5" opacity="0.13"/>
          <rect x="130" y="110" width="12" height="190" fill="#fca5a5" opacity="0.16"/>
          <rect x="150" y="70" width="12" height="230" fill="#fca5a5" opacity="0.09"/>
          <rect x="170" y="130" width="12" height="170" fill="#fca5a5" opacity="0.14"/>
        </svg>

        <svg class="network-bg" viewBox="0 0 300 200" fill="none">
          <circle cx="50" cy="50" r="5" fill="#f87171" opacity="0.4"/>
          <circle cx="120" cy="30" r="4" fill="#f87171" opacity="0.3"/>
          <circle cx="200" cy="60" r="6" fill="#f87171" opacity="0.5"/>
          <circle cx="270" cy="40" r="5" fill="#f87171" opacity="0.4"/>
          <circle cx="80" cy="120" r="4" fill="#f87171" opacity="0.3"/>
          <circle cx="150" cy="100" r="7" fill="#f87171" opacity="0.6"/>
          <circle cx="230" cy="130" r="5" fill="#f87171" opacity="0.4"/>
          <circle cx="180" cy="170" r="6" fill="#f87171" opacity="0.5"/>
          <circle cx="100" cy="180" r="4" fill="#f87171" opacity="0.3"/>
          <line x1="50" y1="50" x2="120" y2="30" stroke="#f87171" stroke-width="1" opacity="0.2"/>
          <line x1="120" y1="30" x2="200" y2="60" stroke="#f87171" stroke-width="1" opacity="0.2"/>
          <line x1="200" y1="60" x2="270" y2="40" stroke="#f87171" stroke-width="1" opacity="0.2"/>
          <line x1="50" y1="50" x2="80" y2="120" stroke="#f87171" stroke-width="1" opacity="0.2"/>
          <line x1="80" y1="120" x2="150" y2="100" stroke="#f87171" stroke-width="1" opacity="0.2"/>
          <line x1="150" y1="100" x2="200" y2="60" stroke="#f87171" stroke-width="1" opacity="0.2"/>
          <line x1="150" y1="100" x2="230" y2="130" stroke="#f87171" stroke-width="1" opacity="0.2"/>
          <line x1="230" y1="130" x2="270" y2="40" stroke="#f87171" stroke-width="1" opacity="0.2"/>
          <line x1="80" y1="120" x2="100" y2="180" stroke="#f87171" stroke-width="1" opacity="0.2"/>
          <line x1="100" y1="180" x2="180" y2="170" stroke="#f87171" stroke-width="1" opacity="0.2"/>
          <line x1="180" y1="170" x2="230" y2="130" stroke="#f87171" stroke-width="1" opacity="0.2"/>
          <line x1="150" y1="100" x2="180" y2="170" stroke="#f87171" stroke-width="1" opacity="0.2"/>
        </svg>
      </div>

      <div class="environment-content">
        <div class="header-section">
          <div class="breadcrumb">
            <button class="back-btn" @click="goBackToSelection">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="15 18 9 12 15 6"></polyline>
              </svg>
              <span>Back to Exposure</span>
            </button>
            <span class="breadcrumb-sep">/</span>
            <span class="breadcrumb-current">{{ analysisLabel }}</span>
          </div>
          <h1 class="page-title">Exposure</h1>
          <p class="page-subtitle">
            {{ analysisType === 'disease' ? 'Exposure–Disease Association Results' : analysisType === 'metabolites' ? 'Exposure–Metabolite Association Results' : 'Exposure Mediation Analysis Results' }}
          </p>
          <p class="page-description">
            {{ pageDescription }}
          </p>
        </div>

        <div class="filters-section">
          <div class="filter-group">
            <label class="filter-label">Exposure Category</label>
            <el-select v-model="selectedCategory" placeholder="Select category" class="filter-select" size="small">
              <el-option
                v-for="cat in categories"
                :key="cat"
                :label="cat"
                :value="cat">
              </el-option>
            </el-select>
          </div>
          <div class="filter-group">
            <label class="filter-label">Exposure</label>
            <el-select v-model="selectedMeasurement" placeholder="Select exposure" class="filter-select" size="small" filterable :filter-method="filterMeasurements">
              <el-option
                v-for="meas in filteredMeasurements"
                :key="meas.phid"
                :label="meas.reportedTrait"
                :value="meas.phid">
              </el-option>
            </el-select>
          </div>
          <div class="filter-group">
            <label class="filter-label">Sex</label>
            <el-select v-model="selectedSex" class="filter-select" size="small">
              <el-option label="All" value="all"></el-option>
              <el-option label="Female" value="female"></el-option>
              <el-option label="Male" value="male"></el-option>
            </el-select>
          </div>
          <template v-if="analysisType === 'mediation'">
            <div class="filter-divider"></div>
            <div class="filter-group">
              <label class="filter-label">Target Disease Category</label>
              <el-select v-model="targetCategory" placeholder="Select target disease category" class="filter-select" size="small" :disabled="!isSourceSelected" filterable>
                <el-option
                  v-for="cat in diseaseCategories"
                  :key="cat"
                  :label="cat"
                  :value="cat">
                </el-option>
              </el-select>
            </div>
            <div class="filter-group">
              <label class="filter-label">Target Disease</label>
              <el-select v-model="targetDisease" placeholder="Select target disease" class="filter-select" size="small" filterable :filter-method="filterTargetDiseases" :disabled="!isSourceSelected">
                <el-option
                  v-for="meas in filteredDiseases"
                  :key="meas.diseaseId"
                  :label="meas.diseaseName"
                  :value="meas.diseaseId">
                </el-option>
              </el-select>
            </div>
            <div class="filter-group">
              <label class="filter-label">Target Sex</label>
              <el-select v-model="targetSex" class="filter-select" size="small" :disabled="!isSourceSelected">
                <el-option label="All" value="all"></el-option>
                <el-option label="Female" value="female"></el-option>
                <el-option label="Male" value="male"></el-option>
              </el-select>
            </div>
          </template>
          <el-button type="danger" @click="handleBrowse" size="small" class="browse-btn">
            <i class="el-icon-search"></i>
            Browse
          </el-button>
        </div>

        <div class="main-content">
          <div class="results-panel">
            <div class="panel-header">
              <div class="panel-title">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                  <polyline points="14 2 14 8 20 8"></polyline>
                  <line x1="16" y1="13" x2="8" y2="13"></line>
                  <line x1="16" y1="17" x2="8" y2="17"></line>
                  <polyline points="10 9 9 9 8 9"></polyline>
                </svg>
                {{ panelTitle }}
              </div>
              <div class="panel-subtitle">Showing exposure-associated results.</div>
              <button class="download-btn" @click="handleDownload">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                  <polyline points="7 10 12 15 17 10"></polyline>
                  <line x1="12" y1="15" x2="12" y2="3"></line>
                </svg>
                Download
              </button>
            </div>
            <div class="table-container" v-loading="tableLoading">
              <table class="results-table">
                <thead>
                  <tr>
                    <th
                      v-for="col in tableColumns"
                      :key="col.key"
                      class="sortable-header"
                      :class="{ active: sortKey === col.key }"
                      @click="handleSort(col.key)"
                    >
                      <span class="header-label">{{ col.label }}</span>
                      <span class="sort-icons">
                        <span class="sort-icon" :class="{ active: sortKey === col.key && sortOrder === 'asc' }">↓</span>
                        <span class="sort-icon" :class="{ active: sortKey === col.key && sortOrder === 'desc' }">↑</span>
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, idx) in tableData" :key="idx">
                    <td v-for="col in tableColumns" :key="col.key">
                      <a
                        v-if="isTraitColumn(col) && row[col.key]"
                        href="#"
                        class="trait-link"
                        @click.prevent="openTraitSearch(row[col.key])"
                      >{{ row[col.key] }}</a>
                      <span v-else-if="col.key === 'category'" class="exposure-badge">{{ row[col.key] }}</span>
                      <span v-else-if="col.key === 'p'" class="p-val">{{ row[col.key] }}</span>
                      <MetaboliteTooltip v-else-if="isMetaboliteColumn(col)" :value="row[col.key]" />
                      <span v-else>{{ row[col.key] }}</span>
                    </td>
                  </tr>
                  <tr v-if="tableData.length === 0 && !tableLoading">
                    <td :colspan="tableColumns.length" class="empty-cell">No data available. Please select filters and click Browse.</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="table-footer">
              <div class="table-info">
                Showing {{ tableData.length > 0 ? (currentPage - 1) * pageSize + 1 : 0 }} to {{ Math.min(currentPage * pageSize, total) }} of {{ total }} results
              </div>
              <div class="pagination">
                <button
                  class="page-btn"
                  :disabled="currentPage <= 1"
                  @click="handlePageChange(currentPage - 1)"
                >
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="15 18 9 12 15 6"></polyline>
                  </svg>
                </button>
                <button
                  v-for="page in visiblePages"
                  :key="page"
                  class="page-btn"
                  :class="{ active: page === currentPage }"
                  @click="handlePageChange(page)"
                >{{ page }}</button>
                <button
                  class="page-btn"
                  :disabled="currentPage >= totalPages"
                  @click="handlePageChange(currentPage + 1)"
                >
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="9 18 15 12 9 6"></polyline>
                  </svg>
                </button>
              </div>
            </div>
            <FieldGlossary
              v-if="tableGlossaryGroups.length"
              class="results-glossary"
              :title="tableGlossaryTitle"
              :groups="tableGlossaryGroups"
              :columns="tableGlossaryColumns"
            />
          </div>

          <div class="charts-panel">
            <div class="chart-card">
              <div class="panel-header">
                <div class="panel-title">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <line x1="18" y1="20" x2="18" y2="10"></line>
                    <line x1="12" y1="20" x2="12" y2="4"></line>
                    <line x1="6" y1="20" x2="6" y2="14"></line>
                  </svg>
                  {{ chartTitle }}
                </div>
                <div class="panel-subtitle">{{ chartSubtitle }}</div>
              </div>
              <div class="chart-container" v-loading="imageLoading">
                <div v-if="topTraitImages.length > 0" class="images-grid">
                  <el-image
                    v-for="(img, idx) in topTraitImages"
                    :key="idx"
                    :src="resolveImageSrc(img)"
                    :alt="resolveImageAlt(img, idx)"
                    class="top-trait-image"
                    :preview-src-list="topTraitImages.map(resolveImageSrc)"
                    fit="contain"
                    @error="handleImageError(idx)"
                  />
                </div>
                <div v-else class="image-placeholder">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                    <circle cx="8.5" cy="8.5" r="1.5"></circle>
                    <polyline points="21 15 16 10 5 21"></polyline>
                  </svg>
                  <span>Select filters and click Browse to view chart</span>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import AnalysisCardSelection from './AnalysisCardSelection.vue'
import request, { downloadFile } from '@/utils/request'
import FieldGlossary from '@/components/FieldGlossary.vue'
import MetaboliteTooltip from '@/components/MetaboliteTooltip.vue'

export default {
  name: 'Exposure',
  components: {
    AnalysisCardSelection,
    FieldGlossary,
    MetaboliteTooltip
  },
  data() {
    return {
      module: 'exposure',
      selectedCategory: '',
      selectedMeasurement: '',
      measurementKeyword: '',
      selectedSex: 'all',
      targetCategory: '',
      targetDisease: '',
      targetDiseaseKeyword: '',
      targetSex: 'all',
      categories: [],
      measurements: [],
      diseaseCategories: [],
      diseases: [],
      tableColumns: [],
      tableData: [],
      tableLoading: false,
      imageLoading: false,
      sortKey: '',
      sortOrder: '',
      currentPage: 1,
      pageSize: 10,
      total: 0,
      totalPages: 0,
      topTraitImages: []
    }
  },
  computed: {
    analysisType() {
      return this.$route.params.analysisType || ''
    },
    analysisLabel() {
      const labels = {
        disease: 'Disease Analysis',
        metabolites: 'Metabolites Analysis',
        mediation: 'Mediation Analysis'
      }
      return labels[this.analysisType] || ''
    },
    panelTitle() {
      const titles = {
        disease: 'Exposure–Disease Associations',
        metabolites: 'Exposure–Metabolite Associations',
        mediation: 'Exposure Mediation Effects'
      }
      return titles[this.analysisType] || 'Exposure Associations'
    },
    pageDescription() {
      const descriptions = {
        disease: 'Select the environmental factor category, specific environmental factor, and sex group, then click Browse to retrieve environmental factor–disease association results. The left panel displays detailed association statistics with downloadable results, while the right panel summarizes the top disease traits ranked by effect size for rapid interpretation.',
        metabolites: 'Select the environmental factor category, specific environmental factor, and sex group, then click Browse to retrieve environmental factor–metabolite association results. The left panel displays detailed association statistics with downloadable results, while the right panel provides a volcano plot highlighting the strongest metabolite associations according to effect size and statistical significance.',
        mediation: 'Select the environmental factor category, specific environmental factor, sex group, target disease category, target disease, and target sex, then click Browse to retrieve environmental factor–metabolite–disease mediation results. The left panel presents detailed mediation statistics with downloadable results, while the right panel highlights the top candidate mediators ranked by effect size for rapid pathway prioritization.'
      }
      return descriptions[this.analysisType] || ''
    },
    chartTitle() {
      const titles = {
        disease: 'Top Disease Traits',
        metabolites: 'Top Metabolite Associations',
        mediation: 'Top five traits ranked by effect size.'
      }
      return titles[this.analysisType] || 'Top Associations'
    },
    chartSubtitle() {
      const subtitles = {
        disease: 'Top five diseases ranked by effect size.',
        metabolites: 'Volcano plot of metabolites by effect size and significance',
        mediation: 'Path diagram of direct vs indirect effects'
      }
      return subtitles[this.analysisType] || ''
    },
    tableGlossaryTitle() {
      return this.analysisType === 'metabolites' ? 'Field Notes' : 'Disease Result Fields'
    },
    tableGlossaryColumns() {
      return this.analysisType === 'metabolites' ? 2 : 1
    },
    tableGlossaryGroups() {
      if (this.analysisType === 'disease') {
        return [{
          items: [
            { term: 'FieldID', description: 'Unique identifier for the disease endpoint.' },
            { term: 'Trait', description: 'Name of the disease or phenotype.' },
            { term: 'Category', description: 'Disease category of the corresponding trait.' },
            { term: 'Beta (β)', description: 'Estimated effect size; the sign indicates the direction of association.' },
            { term: 'CI', description: 'Confidence interval for the estimated effect.' },
            { term: 'Z', description: 'Z statistic for the association test.' },
            { term: 'P', description: 'P value for the association test.' }
          ]
        }]
      }
      if (this.analysisType === 'metabolites') {
        return [{
          items: [
            { term: 'Metabolite', description: 'Name of the metabolite trait.' },
            { term: 'Beta (β)', description: 'Estimated effect size.' },
            { term: 'SE', description: 'Standard error of the estimate.' },
            { term: 't value', description: 't statistic for the association test.' },
            { term: 'P', description: 'P value for the association test.' },
            { term: 'CI', description: 'Confidence interval for the estimated effect.' }
          ]
        }, {
          items: [
            { term: 'N', description: 'Number of samples included in the analysis.' },
            { term: 'df residual', description: 'Residual degrees of freedom.' },
            { term: 'R² (r squared)', description: 'Proportion of variance explained by the model.' },
            { term: 'Model status', description: 'Status of model fitting.' },
            { term: 'P_Bon', description: 'Bonferroni-adjusted P value.' },
            { term: 'P_BH', description: 'Benjamini-Hochberg-adjusted P value.' },
            { term: 'Z_legacy_t_value', description: 'Legacy copy of the t statistic retained for compatibility.' }
          ]
        }]
      }
      return []
    },
    bottomCardTitle() {
      const titles = {
        disease: 'Disease Effect Size Summary',
        metabolites: 'Metabolite Effect Size Summary',
        mediation: 'Mediation Path Effect Summary'
      }
      return titles[this.analysisType] || 'Effect Size Summary'
    },
    visiblePages() {
      const total = this.totalPages
      if (total <= 5) {
        return Array.from({ length: total }, (_, index) => index + 1)
      }

      const pages = [1]
      let start = 2
      let end = 5

      if (this.currentPage > 3 && this.currentPage < total - 2) {
        start = this.currentPage - 1
        end = this.currentPage + 2
      } else if (this.currentPage >= total - 2) {
        start = total - 3
        end = total
      }

      for (let i = start; i <= end; i++) {
        if (i !== 1) {
          pages.push(i)
        }
      }
      return pages
    },
    filteredMeasurements() {
      if (!this.measurementKeyword) return this.measurements
      const keyword = this.measurementKeyword.toLowerCase()
      return this.measurements.filter(m =>
        (m.phid && m.phid.toLowerCase().includes(keyword)) ||
        (m.reportedTrait && m.reportedTrait.toLowerCase().includes(keyword))
      )
    },
    filteredDiseases() {
      if (!this.targetDiseaseKeyword) return this.diseases
      const keyword = this.targetDiseaseKeyword.toLowerCase()
      return this.diseases.filter(m =>
        (m.diseaseId && m.diseaseId.toLowerCase().includes(keyword)) ||
        (m.diseaseName && m.diseaseName.toLowerCase().includes(keyword))
      )
    },
    isSourceSelected() {
      return this.selectedCategory && this.selectedMeasurement
    }
  },
  watch: {
    analysisType() {
      this.selectedCategory = ''
      this.selectedMeasurement = ''
      this.measurementKeyword = ''
      this.selectedSex = 'all'
      this.targetCategory = ''
      this.targetDisease = ''
      this.targetDiseaseKeyword = ''
      this.targetSex = 'all'
      this.tableColumns = []
      this.tableData = []
      this.total = 0
      this.totalPages = 0
      this.currentPage = 1
      this.sortKey = ''
      this.sortOrder = ''
      this.topTraitImages = []
    },
    selectedMeasurement(newVal) {
      if (newVal && this.targetCategory) {
        this.loadDiseases(this.targetCategory)
        this.targetDisease = ''
      }
    },
    selectedCategory(newVal) {
      if (newVal) {
        this.loadMeasurements(newVal)
        this.selectedMeasurement = ''
        this.measurementKeyword = ''
      } else {
        this.measurements = []
      }
    },
    targetCategory(newVal) {
      if (newVal && this.isSourceSelected) {
        this.loadDiseases(newVal)
        this.targetDisease = ''
      } else {
        this.diseases = []
      }
    },
    targetSex() {
      if (this.targetCategory && this.isSourceSelected) {
        this.loadDiseases(this.targetCategory)
        this.targetDisease = ''
      }
    },
  },
  mounted() {
    this.loadCategories()
    this.loadDiseaseCategories()
  },
  methods: {
    goBackToSelection() {
      this.$router.push('/exposure')
    },
    async loadCategories() {
      try {
        const data = await request.get(`/api/${this.module}/categories`)
        this.categories = data || []
      } catch (error) {
        console.error('Failed to load categories:', error)
      }
    },
    async loadMeasurements(category) {
      try {
        const data = await request.get(`/api/${this.module}/list`, {
          params: { category }
        })
        this.measurements = data || []
      } catch (error) {
        console.error('Failed to load measurements:', error)
      }
    },
    async loadDiseaseCategories() {
      try {
        const data = await request.get(`/api/${this.module}/mediation/disease/categories`)
        this.diseaseCategories = data || []
      } catch (error) {
        console.error('Failed to load disease categories:', error)
      }
    },
    async loadDiseases(category) {
      try {
        const data = await request.get(`/api/${this.module}/mediation/disease/list`, {
          params: { phid: this.selectedMeasurement, category, sex: this.targetSex }
        })
        this.diseases = data || []
        this.targetDiseaseKeyword = ''
      } catch (error) {
        console.error('Failed to load diseases:', error)
      }
    },
    filterMeasurements(keyword) {
      this.measurementKeyword = keyword
    },
    filterTargetDiseases(keyword) {
      this.targetDiseaseKeyword = keyword
    },
    handleBrowse() {
      if (!this.selectedCategory) {
        this.$message.warning('Please select a Category.')
        return
      }
      if (!this.selectedMeasurement) {
        this.$message.warning('Please select an Exposure.')
        return
      }
      if (this.analysisType === 'mediation' &&
          (!this.targetDisease || !this.targetCategory)) {
        this.$message.warning('Please select both Target Disease Category and Target Disease.')
        return
      }
      this.currentPage = 1
      this.loadTableData()
      this.loadTopTraitImage()
    },
    handleSort(columnKey) {
      if (this.sortKey !== columnKey) {
        this.sortKey = columnKey
        this.sortOrder = 'desc'
      } else if (this.sortOrder === 'desc') {
        this.sortOrder = 'asc'
      } else if (this.sortOrder === 'asc') {
        this.sortKey = ''
        this.sortOrder = ''
      } else {
        this.sortOrder = 'desc'
      }
      this.currentPage = 1
      this.loadTableData()
    },
    isTraitColumn(column) {
      const value = `${column.key || ''} ${column.label || ''}`.toLowerCase()
      return value.includes('trait')
    },
    isMetaboliteColumn(column) {
      const value = `${column.key || ''} ${column.label || ''}`.toLowerCase()
      return value.includes('metabolite')
    },
    openTraitSearch(trait) {
      const keyword = String(trait || '').trim()
      if (keyword) {
        this.$router.push({ path: '/global-search', query: { keyword } })
      }
    },
    async handleDownload() {
      if (!this.selectedCategory) {
        this.$message.warning('Please select a Category.')
        return
      }
      if (!this.selectedMeasurement) {
        this.$message.warning('Please select an Exposure.')
        return
      }
      if (this.analysisType === 'mediation' &&
          (!this.targetDisease || !this.targetCategory)) {
        this.$message.warning('Please select both Target Disease Category and Target Disease.')
        return
      }
      const params = {
        phid: this.selectedMeasurement,
        sex: this.selectedSex
      }
      if (this.analysisType === 'mediation') {
        params.targetDisease = this.targetDisease
        params.targetSex = this.targetSex
      }
      await downloadFile(`/api/${this.module}/${this.analysisType}/download`, params, `exposure_${this.analysisType}_${this.selectedMeasurement}.tsv`)
    },
    async loadTableData() {
      this.tableLoading = true
      try {
        const params = {
          category: this.selectedCategory,
          phid: this.selectedMeasurement,
          sex: this.selectedSex,
          pageNum: this.currentPage,
          pageSize: this.pageSize
        }
        if (this.sortKey && this.sortOrder) {
          params.sortBy = this.sortKey
          params.sortOrder = this.sortOrder
        }
        if (this.analysisType === 'mediation') {
          params.targetDisease = this.targetDisease
          params.targetCategory = this.targetCategory
          params.targetSex = this.targetSex
        }
        const data = await request.get(`/api/${this.module}/${this.analysisType}/page`, { params })
        const headers = data.headers || []
        const records = data.records || []
        this.tableColumns = headers.map(h => ({ key: h, label: h }))
        this.tableData = records.map(row => {
          const obj = {}
          headers.forEach((h, i) => { obj[h] = row[i] })
          return obj
        })
        this.total = data.total || 0
        this.totalPages = data.pages || 0
      } catch (error) {
        console.error('Failed to load table data:', error)
        this.tableColumns = []
        this.tableData = []
        this.total = 0
        this.totalPages = 0
      } finally {
        this.tableLoading = false
      }
    },
    async loadTopTraitImage() {
      if (!this.selectedMeasurement || !this.selectedCategory) {
        this.topTraitImages = []
        return
      }
      if (this.analysisType === 'mediation' &&
          (!this.targetDisease || !this.targetCategory)) {
        this.topTraitImages = []
        return
      }
      this.imageLoading = true
      this.topTraitImages = []
      try {
        const params = {
          category: this.selectedCategory,
          phid: this.selectedMeasurement,
          sex: this.selectedSex
        }
        if (this.analysisType === 'mediation') {
          params.targetDisease = this.targetDisease
          params.targetCategory = this.targetCategory
          params.targetSex = this.targetSex
        }
        const imageData = await request.get(`/api/${this.module}/${this.analysisType}/top-trait-image`, { params })
        this.topTraitImages = this.normalizeImageList(imageData)
          .map(item => this.normalizeImageResource(item))
          .filter(Boolean)
      } catch (error) {
        console.error('Failed to load top trait image:', error)
        this.topTraitImages = []
      } finally {
        this.imageLoading = false
      }
    },
    normalizeImageList(imageData) {
      if (!imageData) return []
      if (Array.isArray(imageData)) return imageData
      if (Array.isArray(imageData.data)) return imageData.data
      return [imageData]
    },
    normalizeImageResource(item) {
      if (!item) return null

      if (typeof item === 'string') {
        const normalizedPayload = item.trim().replace(/\s+/g, '')
        return {
          name: '',
          type: 'image/png',
          src: normalizedPayload.startsWith('data:image') ? normalizedPayload : `data:image/png;base64,${normalizedPayload}`
        }
      }

      const type = this.normalizeImageType(item.type || item.contentType)
      const resource = item.resource
      const payload = item.data || item.base64 || item.content || (
        typeof resource === 'string'
          ? resource
          : resource && typeof resource === 'object'
            ? (resource.data || resource.base64 || resource.content || resource.url || '')
            : ''
      )

      if (!payload || typeof payload !== 'string') return null

      const normalizedPayload = payload.trim().replace(/\s+/g, '')
      let src = ''
      if (normalizedPayload.startsWith('data:image')) {
        src = normalizedPayload
      } else if (type === 'file') {
        src = /^(https?:)?\/\//.test(normalizedPayload) || normalizedPayload.startsWith('/') ? normalizedPayload : ''
      } else {
        src = `data:${type};base64,${normalizedPayload}`
      }

      if (!src) return null

      return {
        name: item.name || '',
        type,
        src
      }
    },
    normalizeImageType(type) {
      if (!type || typeof type !== 'string') return 'image/png'

      const normalizedType = type.trim().toLowerCase()
      if (normalizedType.startsWith('image/')) return normalizedType
      if (normalizedType === 'image') return 'image/png'
      if (normalizedType === 'file') return 'file'

      return 'image/png'
    },
    resolveImageSrc(item) {
      if (!item) return ''
      return typeof item === 'string' ? item : (item.src || '')
    },
    resolveImageAlt(item, idx) {
      if (item && typeof item === 'object' && item.name) return item.name
      return `${this.chartTitle} ${idx + 1}`
    },
    handleImageError(index) {
      if (typeof index === 'number') {
        this.topTraitImages.splice(index, 1)
        return
      }
      this.topTraitImages = []
    },
    handlePageChange(page) {
      if (page >= 1 && page <= this.totalPages && page !== this.currentPage) {
        this.currentPage = page
        this.loadTableData()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.environment {
  min-height: 100%;
  position: relative;
  overflow: hidden;
  background: linear-gradient(180deg, #fef2f2 0%, #ffffff 100%);
}

.bg-decoration {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  overflow: hidden;
}

.molecule-bg {
  position: absolute;
  width: 400px;
  height: 400px;
  top: 20px;
  left: -50px;
}

.bars-bg {
  position: absolute;
  width: 200px;
  height: 300px;
  bottom: 80px;
  left: -20px;
}

.network-bg {
  position: absolute;
  width: 350px;
  height: 250px;
  bottom: 60px;
  right: -30px;
}

.environment-content {
  position: relative;
  z-index: 1;
  margin: 0 auto;
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 64px);
}

.breadcrumb {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  justify-content: center;
}

.back-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: none;
  color: #991b1b;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  padding: 4px 0;
  transition: opacity 0.2s;

  svg {
    width: 16px;
    height: 16px;
  }

  &:hover {
    opacity: 0.7;
  }
}

.breadcrumb-sep {
  color: #d1d5db;
  font-size: 13px;
}

.breadcrumb-current {
  font-size: 13px;
  font-weight: 600;
  color: #991b1b;
}

.header-section {
  text-align: center;
  margin-bottom: 20px;
}

.filters-section {
  display: flex;
  gap: 16px;
  align-items: flex-end;
  justify-content: center;
  margin-bottom: 24px;
  flex-wrap: wrap;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.filter-label {
  font-size: 14px;
  font-weight: 500;
  color: #374151;
}

.filter-select {
  min-width: 220px;
}

.filter-divider {
  width: 1px;
  height: 32px;
  background: #e5e7eb;
  align-self: flex-end;
  margin: 0 4px;
}

.browse-btn {
  margin-left: 8px;
}

.page-title {
  font-size: 40px;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 8px 0;
  line-height: 1.3;
}

.page-subtitle {
  font-size: 16px;
  color: #6b7280;
  margin: 0;
  line-height: 1.6;
}

.page-description {
  max-width: 980px;
  font-size: 14px;
  color: #4b5563;
  margin: 12px auto 0;
  line-height: 1.7;
  text-align: center;
}

.main-content {
  display: grid;
  grid-template-columns: 3fr 2fr;
  gap: 16px;
  flex: 1;
  align-items: stretch;
}

.results-panel {
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
  border: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
  min-width: 0;
  width: 100%;
}

.chart-card {
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
  border: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.panel-header {
  padding: 12px 16px;
  border-bottom: 1px solid #f3f4f6;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.panel-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 600;
  color: #1f2937;

  svg {
    width: 18px;
    height: 18px;
    color: #ef4444;
  }
}

.panel-subtitle {
  font-size: 12px;
  color: #9ca3af;
  flex: 1;
}

.download-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 7px 14px;
  background: linear-gradient(135deg, #fff1f2 0%, #ffe4e6 100%);
  color: #991b1b;
  border: 1px solid #fecaca;
  border-radius: 10px;
  box-shadow: 0 6px 16px rgba(239, 68, 68, 0.12);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  svg {
    width: 14px;
    height: 14px;
  }

  &:hover {
    background: linear-gradient(135deg, #fee2e2 0%, #fecdd3 100%);
    border-color: #fca5a5;
    color: #7f1d1d;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
}

.table-container {
  flex: none;
  margin-top: 12px;
  max-height: 520px;
  overflow-y: auto;
  overflow-x: auto;
}

.results-glossary {
  margin: 12px 16px 16px;
}

.trait-link {
  color: #991b1b;
  text-decoration: underline;
  text-decoration-color: rgba(153, 27, 27, 0.35);
  text-underline-offset: 2px;
  cursor: pointer;
}

.trait-link:hover {
  color: #b91c1c;
}

.results-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  table-layout: auto;

  th {
    padding: 10px 12px;
    text-align: left;
    font-weight: 600;
    color: #374151;
    background: #f9fafb;
    border-bottom: 1px solid #e5e7eb;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  td {
    padding: 10px 12px;
    color: #4b5563;
    border-bottom: 1px solid #f3f4f6;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 200px;
  }

  tbody tr {
    transition: background 0.15s ease;

    &:hover {
      background: #fafafa;
    }
  }
}

.sortable-header {
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
}

.header-label {
  display: inline-block;
  vertical-align: middle;
}

.sort-icons {
  display: inline-flex;
  gap: 2px;
  margin-left: 6px;
  vertical-align: middle;
}

.sort-icon {
  color: #c4c4c4;
  font-size: 12px;
  line-height: 1;
  transition: color 0.2s ease;
}

.sort-icon.active,
.sortable-header.active .sort-icon.active {
  color: #dc2626;
}

.empty-cell {
  text-align: center;
  color: #9ca3af;
  padding: 40px 12px;
  font-size: 14px;
}

.exposure-badge {
  display: inline-block;
  padding: 2px 8px;
  background: #fef2f2;
  color: #991b1b;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 500;
}

.p-val {
  font-family: monospace;
  font-size: 12px;
}

.table-footer {
  padding: 10px 16px;
  border-top: 1px solid #f3f4f6;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.table-info {
  font-size: 13px;
  color: #9ca3af;
}

.pagination {
  display: flex;
  gap: 4px;
}

.page-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  color: #6b7280;
  transition: all 0.2s ease;

  svg {
    width: 14px;
    height: 14px;
  }

  &:hover:not(:disabled) {
    border-color: #ef4444;
    color: #ef4444;
  }

  &.active {
    background: #991b1b;
    border-color: #991b1b;
    color: #ffffff;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

.charts-panel {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-height: 100%;
}

.images-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  width: 100%;
  padding: 8px 0;
  height: 100%;
  align-items: center;
}

.panel-title-sm {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 600;
  color: #1f2937;
  padding: 12px 16px 8px;

  svg {
    width: 18px;
    height: 18px;
    color: #ef4444;
  }
}

.chart-container {
  padding: 12px 16px 20px;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 360px;
}

.top-trait-image {
  width: 100%;
  max-width: none;
  height: auto;
  object-fit: contain;
  border-radius: 4px;
}

:deep(.top-trait-image .el-image__inner) {
  width: 100%;
  height: auto;
  object-fit: contain;
  border-radius: 4px;
}

.image-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 40px 20px;
  color: #9ca3af;
  font-size: 13px;
  text-align: center;

  svg {
    width: 48px;
    height: 48px;
    color: #d1d5db;
  }
}

.chart-note {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 16px 16px;
  color: #6b7280;
  font-size: 12px;

  svg {
    width: 18px;
    height: 18px;
    color: #9ca3af;
  }
}

@media (max-width: 1200px) {
  .main-content {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .environment-content {
    padding: 24px 16px;
  }

  .page-title {
    font-size: 28px;
  }

  .category-tabs {
    gap: 8px;
  }

  .category-tab {
    padding: 8px 14px;
    font-size: 13px;
  }
}
</style>
